import React from 'react'
import Radium from 'radium'
import { semanticColors } from '../../../../../Globals/styles'

const Cell = ({ content, style, inputStyle, readOnly, onChange, onFocus, onFocusOut, onClick, inputClassName, children, ref, values }) => {
    return (
        <div style={[styles.cell, style]}
            onClick={() => { onClick ? onClick() : {} }}>
            <select
                className={inputClassName}
                ref={ref ? ref : undefined}
                value={content}
                style={[styles.input, inputStyle]}
                onFocus={() => onFocus ? onFocus() : {}}
                onBlur={() => onFocusOut ? onFocusOut() : {}}
                onChange={(e) => {
                    if (onChange) {
                        onChange(e.target.value)
                    }
                }}                >
                {values}
            </select>
            {children}
        </div>
    );
}

const styles = {
    cell: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    },
    input: {
        '-webkit-appearance': 'none',
        '-moz-appearance':    'none',
        '-webkit-border-radius': '0px',
        backgroundColor: 'white',
        cursor: 'pointer',
        width:' 100%',
        height: '35px',
        border: 'none',
        padding: '5px'
    },
}

export default Radium(Cell);


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/spreadsheets/table/cellSelect.js